import { onStructureReceiveForTable } from './structure_tool_on_reveive_for_table';
import { StructureTool } from './structure_tool';

export function generateTableConfig(structure_tool: StructureTool, entity: string, hiddenColumns: ReadonlyArray<string>, showingColumns: ReadonlyArray<string>,
        examples: any, filterModes: any, getdata: () => ReadonlyArray<any>,
        callback: (columns: Array<any>) => void,
        customFormatter?: (field: string, value: any, row?: any) => any,
        bundle?: any,
        customFilterTranslator?: (key: string, value: string) => string, summaryCondition?: (row: any) => boolean) {
        structure_tool.getStructureByModul(structure_tool.modul, (data: any) => {
            // console.log('GENERATE TABLE CONFIG: ', this.modul, entity, data);
            onStructureReceiveForTable(structure_tool, entity, data, hiddenColumns, showingColumns, examples, filterModes, getdata, callback,
                customFormatter, bundle, customFilterTranslator, summaryCondition);
        }, false);
    }